<nav #navbar class="navbar">
  <div class="container-fluid">
    <div class="navbar-header d-flex align-items-center flex-row-reverse" style="padding: 0; border-right:unset">
      <a class="noti">
        <li class="nav-item dropdown-notifications noti-drop" ngbDropdown id="dropdown-notifications">
          <button mat-icon-button ngbDropdownToggle class="nav-notification-icons" style="font-size: large;">
            <i class="nav-hdr-btn far fa-bell" (click)="refreshNotification()"></i>
            <!-- <span class="notify"></span>
            <span class="heartbeat"></span> -->
            <span class="notification noti-mobile"
              *ngIf="0<numberOfNotifications && numberOfNotifications<6">{{numberOfNotifications}}</span>
            <span class="notification over_5" *ngIf="6 <= numberOfNotifications">5+</span>
          </button>
          <div ngbDropdownMenu class="notification-dropdown pullDown header-drop" style="margin: 0 !important;">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 250px;" [perfectScrollbar]>
              <ul class="menu">
                <li *ngFor="let notification of notifications  , let i = index" (click)="ViewRequest(notification)">
                  <a *ngIf="i<6" class="notification-item">
                    <div class="notification-content d-flex justify-content-between align-items-start">
                      <div class="notification-detalis">
                        <p class="notification-name m-0">{{notification.name}}</p>
                        <p class="notification-describtion">{{notification.describtion}}</p>
                        <!-- <p class="notification-describtion">{{notification.describtion}}</p> -->
                      </div>
                      <span class="notification-time d-flex align-items-center">
                        <i class="material-icons mx-2">access_time</i> {{notification.hours}} {{'hour' | translate}}
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <a *ngIf="notification?.count==0" class="text-center d-block py-1" style="color: var(--subColor);">
              {{'noNotif' | translate}}</a>
            <a class="text-center d-block border-top py-1 ps-20" (click)="closeDropDown('/page/view-all-notifications')"
              style="color: var(--subColor); cursor: pointer;">
              {{'readAllNotifications' | translate}}</a>
          </div>
        </li>
      </a>
      <a class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>

      <!-- <a class="navbar-brand" routerLink="/page/home" style="margin:auto; height: 60px;">
        <img src="assets/images/4signing3.png" alt="" />
        <span class="logo-name">{{"SystemTitle" | translate}}</span>
      </a> -->
      <a class="navbar-toggle collapsed" (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <a class="navbar-brand show-logo" id="big-Logo" routerLink="page/home" style="height: 60px;">
        <img src="assets/images/4signing2.png" alt="" style="height: 100% ; width: 100%;padding-left: 15px;padding-right: 15px;" />
        <!-- <span class="logo-name my-auto">{{"SystemTitle" | translate}}</span> -->
      </a>
      <a class="navbar-brand hide-logo" id="small-Logo" routerLink="page/home" style=" height: 60px;">
        <img src="assets/images/4signing5.png" alt="" style="width: 85%;padding-left: 5px;" />
        <span class="logo-name my-auto">{{"SystemTitle" | translate}}</span>
      </a>
    </div>
    <div class="collapse navbar-collapse" id="collapse " [ngbCollapse]="isNavbarCollapsed">
      <ul class="pull-left collapse-menu-icon">
        <li>
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
            <i class="nav-hdr-btn ti-align-left"></i>
          </button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <!-- Full Screen Button -->
        <li class="fullscreen">
          <button mat-icon-button (click)="callFullscreen()" class=" nav-notification-icons">
            <i class="nav-hdr-btn ti-fullscreen"></i>
          </button>
        </li>
        <li class="nav-item">
          <a class="lang">
            <button (click)="changeLang()" id="language">English</button>
          </a>
        </li>
        <!-- <li class="nav-item dropdown-notifications" ngbDropdown id="dropdown-notifications">
          <button mat-icon-button ngbDropdownToggle class="nav-notification-icons">
            <i class="nav-hdr-btn fas fa-bell" (click)="refreshNotification()"></i>

            <span class="notification" *ngIf="notification && notification?.count>0">{{notification?.count}}</span>

          </button>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div class="removeBtn" style="text-align: center;">
              <button mat-raised-button type="button" class="btn btn-success" (click)="deleteNotifications()"
                [disabled]="notification?.count==0"> {{'deleteNoti' | translate}} </button>
            </div>
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 250px;" [perfectScrollbar]>
              <ul class="menu">
                <li *ngFor="let msg of messages" [ngSwitch]="msg.tranType">
                  <a class="notification-item">
                    <div class="notification-content d-flex justify-content-between align-items-start">
                      <div class="notification-detalis">
                        <p *ngSwitchCase="'Add'" class="notification-name m-0"> {{'addEmp' | translate}} <span
                            style="color: #002447;">'{{msg.employeeName}}'</span></p>
                        <p *ngSwitchCase="'Edit'" class="notification-name m-0" style="color: #17a2b8;">
                          {{'editEmp' | translate}} <span style="color: #002447;">'{{msg.employeeName}}'</span></p>
                        <p *ngSwitchCase="'Delete'" class="notification-name m-0" style="color: #c82333;">
                          {{'deleteEmp' | translate}}<span style="color: #002447;">'{{msg.employeeName}}'</span></p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <a *ngIf="notification?.count==0" class="text-center d-block py-1" style="color: var(--subColor);">
              {{'noNoti' | translate}}</a>
            <a class="text-center d-block border-top py-1" (click)="closeDropDown('/page/view-all-notifications')"
              style="color: var(--subColor);">
              {{'readAllNotification' | translate}}</a>
          </div>
        </li> -->
        <li class="nav-item dropdown-notifications" ngbDropdown id="dropdown-notifications">
          <button mat-icon-button ngbDropdownToggle class="nav-notification-icons" style="padding-top: 13px;
          padding-left: 10px;">
            <i class="nav-hdr-btn far fa-bell" (click)="refreshNotification()"></i>
            <!-- <span class="notify"></span>
            <span class="heartbeat"></span> -->
            <span class="notification"
              *ngIf="0<numberOfNotifications && numberOfNotifications<6">{{numberOfNotifications}}</span>
            <span class="notification over_5" *ngIf="6 <= numberOfNotifications">5+</span>
          </button>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 250px;" [perfectScrollbar]>
              <ul class="menu">
                <li *ngFor="let notification of notifications  , let i = index" (click)="ViewRequest(notification)">
                  <a *ngIf="i<6" class="notification-item">
                    <div class="notification-content d-flex justify-content-between align-items-start">
                      <div class="notification-detalis">
                        <p class="notification-name m-0" *ngIf="!showNotiEng">{{notification.name}}</p>
                        <p class="notification-name m-0" *ngIf="showNotiEng">{{notification.processNameEng}}</p>
                        <p class="notification-describtion m-0"> {{'notificationdescribtion' | translate}} {{notification.describtion}}</p>
                        <!-- <p class="notification-describtion">{{notification.describtion}}</p> -->
                      </div>
                      <span class="notification-time d-flex align-items-center">
                        <i class="material-icons mx-2">access_time</i> {{notification.hours}} {{'hour' | translate}}
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <a *ngIf="notification?.count==0" class="text-center d-block py-1" style="color: var(--subColor);">
              {{'noNotif' | translate}}</a>
            <a class="text-center d-block border-top py-1" (click)="closeDropDown('/page/view-all-notifications')"
              style="color: var(--subColor); cursor: pointer;">
              {{'readAllNotifications' | translate}}</a>
          </div>
        </li>
        <!-- #END# Notifications-->
        <li class="nav-item user_profile" ngbDropdown>
          <a ngbDropdownToggle role="button" class="nav-notification-icons pt-0">
            <img src="assets/images/user.jpg" class="rounded-circle" width="32" height="32" alt="User">
          </a>
          <div ngbDropdownMenu class="notification-dropdown pullDown ">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 300px;" [perfectScrollbar]>
              <ul class="menu">
                <li class="body">
                  <ul class="user_dw_menu">
                    <li (click)="closeDropDown('/page/Profile')">
                      <a style="font-size: larger;cursor: pointer;">
                        <mat-icon aria-hidden="false" class="mr-2" style="
                        margin-right: 5px;
                        margin-left: 5px;
                    ">person</mat-icon> {{'Profile' | translate}}
                      </a>
                    </li>

                    <li (click)="closeDropDown('/page/changePassword')">
                      <a style="font-size: larger;cursor: pointer;">
                        <mat-icon aria-hidden="false" class="mr-2" style="
                        margin-right: 5px;
                        margin-left: 5px;
                    ">password</mat-icon> {{'ChangePassword' | translate}}
                      </a>
                    </li>

                    <!-- <li *ngIf="this.showPack===true" (click)="closeDropDown('/page/myPayments')">
                      <a style="font-size: larger;cursor: pointer;">
                        <mat-icon aria-hidden="false" class="mr-2" style="
                        margin-right: 5px;
                        margin-left: 5px;
                    ">credit_card</mat-icon> {{'MyPayments' | translate}}
                      </a>
                    </li> -->

                    <li *ngIf="this.showPack===true" (click)="closeDropDown('/page/myPackages')">
                      <a style="font-size: larger;cursor: pointer;">
                        <mat-icon aria-hidden="false" class="mr-2" style="
                        margin-right: 5px;
                        margin-left: 5px;
                    ">card_membership</mat-icon> {{'MyPackages' | translate}}
                      </a>
                    </li>
                    <!-- <li>
                      <a href="#" onClick="return false;">
                        <mat-icon aria-hidden="false" class="mr-2">feedback</mat-icon>Feedback
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick="return false;">
                        <mat-icon aria-hidden="false" class="mr-2">help</mat-icon>Help
                      </a>
                    </li> -->
                    <li>
                      <a href="javascript:void(0);" (click)="logout()" style="font-size: larger">
                        <mat-icon aria-hidden="false" class="mr-2" style="
                        margin-right: 5px;
                        margin-left: 5px;
                    ">power_settings_new</mat-icon> {{'logout' | translate}}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <!-- #END# Tasks -->
        <!-- <li class="pull-right">
          <button mat-icon-button (click)="toggleRightSidebar()" class="nav-notification-icons">
            <i class="nav-hdr-btn ti-layout-grid2" id="settingBtn"></i>
          </button>
        </li> -->
      </ul>

      <ul class="nav navbar-nav navbar-center" *ngIf="this.days<=15">
        <li id="account-info">
          <a>
            <!-- <i class="fa fa-exclamation-circle" aria-hidden="true" style="color:#8ac33f"></i> -->
            <img src="../../../assets/images/icons/warning-blink.gif" alt="" width="20px" style="margin: 0 5px;">
            {{'remain' | translate}} {{this.days}} {{'days' | translate}}</a>
        </li>
      </ul>

      <ul class="nav navbar-nav navbar-center company-info" style="padding: 0; float: right; margin: 0;">
        <li><a class="companyName" routerLink="/page/home"><span
              style="font-size: large;font-weight: 100; margin-left: 10px; margin-right: 10px;">{{this.company?.companyName}}</span></a>
        </li>
        <li>
          <div class="companyLogoContainer" style="width: 55px;" *ngIf="this.company?.logo">
            <img [src]="base64Image"
              onerror="this.onerror=null;this.src='../../../../../assets/images/placeholder-image.png';"
              style="border-radius: 50%;border: 1px solid #8ac33f;width: 80%;height: 40px;">
          </div>
        </li>
      </ul>

    </div>
  </div>
</nav>>
